<template>
    <svg :width="size" :height="size" viewBox="0 0 30 30">
        <defs>
            <path
                id="add-path-1"
                d="M12.1482643,-0.148264325 C12.5900921,-0.148264325 12.9482643,0.209907875 12.9482643,0.651735675 L12.9472643,11.0507357 L23.3482643,11.0517357 C23.7900921,11.0517357 24.1482643,11.4099079 24.1482643,11.8517357 C24.1482643,12.2935635 23.7900921,12.6517357 23.3482643,12.6517357 L12.9472643,12.6507357 L12.9482643,23.0517357 C12.9482643,23.4935635 12.5900921,23.8517357 12.1482643,23.8517357 C11.7064365,23.8517357 11.3482643,23.4935635 11.3482643,23.0517357 L11.3472643,12.6507357 L0.948264325,12.6517357 C0.506436525,12.6517357 0.148264325,12.2935635 0.148264325,11.8517357 C0.148264325,11.4099079 0.506436525,11.0517357 0.948264325,11.0517357 L11.3472643,11.0507357 L11.3482643,0.651735675 C11.3482643,0.209907875 11.7064365,-0.148264325 12.1482643,-0.148264325 Z"
            ></path>
        </defs>
        <g id="Asset-Artboard-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icons-/-Cancel-Icons-/-Regular-/-Cancel">
                <mask id="add-mask-2" :fill="color"></mask>
                <use
                    id="Mask"
                    :fill="color"
                    transform="translate(12.148264, 11.851736) rotate(-315.000000) translate(-12.148264, -11.851736) "
                    xlink:href="#add-path-1"
                ></use>
                <g id="Color-/-Grey-Color-/-White" mask="url(#add-mask-2)" fill="#FFFFFF">
                    <g id="Rectangle" transform="translate(-4.000000, -4.000000)">
                        <rect x="0" y="0" width="32" height="32"></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'CloseSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
